import { render } from "./ServerLb.vue?vue&type=template&id=64217ba8"
import script from "./ServerLb.vue?vue&type=script&lang=js"
export * from "./ServerLb.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__